import { Box, Stack, useMediaQuery } from '@mui/material';
import { Theme } from '@mui/system';
import React from 'react';

import { BackButton } from '../../../../general/components/back-button';
import { StoreInfoSecurelyNote } from '../../../../general/components/store-info-securely-note';
import { useWizardBack } from '../../../../general/components/wizard-page';
import { SubmitWorkflowButton } from '../submit-workflow-button';

const MOBILE_BAR_HEIGHT = 8.5;

type Props = React.ComponentProps<typeof SubmitWorkflowButton>;

const SubmitWorkflowWithBack: React.FC<Props> = ({ disableNote, children, ...props }: Props) => {
  const handleBack = useWizardBack();
  const mobile = useMediaQuery((theme: Theme) => {
    return theme.breakpoints.down('sm');
  });

  if (!handleBack) {
    return (
      <SubmitWorkflowButton disableNote={disableNote} {...props}>
        {children}
      </SubmitWorkflowButton>
    );
  }

  const submit = (
    <SubmitWorkflowButton disableNote {...props}>
      {children}
    </SubmitWorkflowButton>
  );
  const note = !disableNote && <StoreInfoSecurelyNote sx={{ mt: 2 }} />;

  if (mobile) {
    return (
      <>
        {note}
        <Box
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: (theme) => theme.zIndex.appBar,
            height: (theme) => theme.spacing(MOBILE_BAR_HEIGHT),
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            px: 2.5,
            bgcolor: 'background.paper',
            borderTop: 1,
            borderColor: 'divider',
            '& .MuiButton-root': { m: 0 },
          }}
        >
          <BackButton size="medium" fullWidth={false} />
          <Box flex={1}>{submit}</Box>
        </Box>
      </>
    );
  }

  return (
    <>
      <Stack direction="row" spacing={2} mt={3} sx={{ '& .MuiButton-root': { my: 0 } }}>
        <Box flex={1}>
          <BackButton />
        </Box>
        <Box flex={1}>{submit}</Box>
      </Stack>
      {note}
    </>
  );
};

export { SubmitWorkflowWithBack };
